import { useQuery } from "@tanstack/react-query";
import Big from "big.js";
import { usePublicClient } from "wagmi";
import { GATEWAY_ABI } from "@/contract/abi/gateway";
import ContractAddress from "@/contract/addresses";
import { useEffectiveAddress } from "@/hooks/auth/useEffectiveAddress";
import { $api } from "@/lib/api-client";

export const useIsLatestId = () => {
  const address = useEffectiveAddress();
  const pc = usePublicClient();

  const result = $api.useQuery(
    "get",
    "/order/latest-id",
    {},
    {
      queryKey: ["order", "latest-id"],
      enabled: !!pc,
    },
  );

  // openapi-react-query returns { data: WrappedApiResponseDto }
  // Access result.data.data to get the actual response data
  const latestOrderData = result.data?.data;

  return useQuery({
    queryKey: [address, "isLatestId"],
    queryFn: async (): Promise<boolean> => {
      const lastestId = await pc?.readContract({
        address: ContractAddress.GATEWAY,
        abi: GATEWAY_ABI,
        functionName: "order_id",
      });

      const lastestIdFix = Big(lastestId?.toString() || "0").toNumber();

      if (!latestOrderData) {
        return false;
      }

      // Type guard to check if latestOrderData has order_id
      if (
        latestOrderData &&
        typeof latestOrderData === "object" &&
        latestOrderData !== null &&
        "order_id" in latestOrderData
      ) {
        const orderId = latestOrderData.order_id;
        if (typeof orderId === "number") {
          return lastestIdFix === orderId;
        }
      }

      return false;
    },
    enabled: !!pc && !!latestOrderData,
  });
};
